import { render } from "./Ads.vue?vue&type=template&id=25a7ee05&scoped=true"
import script from "./Ads.vue?vue&type=script&lang=js"
export * from "./Ads.vue?vue&type=script&lang=js"

import "./Ads.vue?vue&type=style&index=0&id=25a7ee05&lang=css"
import "./Ads.vue?vue&type=style&index=1&id=25a7ee05&scoped=true&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a7ee05"]])

export default __exports__